import { useEffect, useState } from 'react';
import { Button, Form, message, Upload, UploadProps } from 'antd';
import { StarOutlined, UploadOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd';
import axios, { AxiosError } from 'axios';
import moment from 'moment';



export const useCustomerModal = (form: FormInstance) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleSelectCustomer = (customer: any) => {
        form.setFieldsValue({
            cs_code: customer.cs_code,
            name_customer: customer.cs_name,
        });
        handleCancel();
    };
    
    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            const formData = new FormData();

            
            Object.keys(values).forEach(key => {
                if (key === 'document') {
                    
                    if (values[key]?.length > 0) {
                        values[key].forEach((file: { originFileObj: Blob }) => {
                            formData.append('document', file.originFileObj);
                        });
                    } else if (form.getFieldValue('document')) {
                        formData.append('document', form.getFieldValue('document'));
                    }
                } else if (key === 'expired') {
                    formData.append(key, values[key].format('DD-MM-YYYY')); 
                } else {
                    formData.append(key, values[key]);
                }
            });

            const id = form.getFieldValue('id');
            const config = {
                headers: { 'Content-Type': 'multipart/form-data' },
            };

            if (id) {
                await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/agreements/${id}`, formData, config);
                message.success('Data berhasil diupdate!');
            } else {
                await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/agreements`, formData, config);
                message.success('Data berhasil disimpan!');
            }

            form.resetFields();
        } catch (error) {
            if (axios.isAxiosError(error)) { 
                const errorMessage = error.response?.data?.error || 'Server error';
                message.error(`Gagal: ${errorMessage}`);
            } else {
                message.error('Gagal: Terjadi kesalahan tidak terduga');
            }
        }
    };
    useEffect(() => {
        const savedData = localStorage.getItem('selectedCustomer');
        if (savedData) {
            const {
                no_agreement,
                cs_code,
                name_customer,
                reference_no,
                disc,
                expired,
                status,
                document
            } = JSON.parse(savedData);

            
            form.setFieldsValue({
                no_agreement,
                cs_code,
                name_customer,
                reference_no,
                disc,
                expired: moment(expired, 'DD/MM/YYYY'),
                status: parseInt(status),
                document: document
            });
            setIsEditing(true); 
        }
    }, [form]);

    return {
        isModalVisible,
        showModal,
        handleCancel,
        handleSelectCustomer,
        handleSubmit,
        isEditing
    };
};


export const uploadProps: UploadProps = {
    accept: '.pdf',
    multiple: false, 
    beforeUpload: (file) => {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
            message.error('Hanya file PDF yang diizinkan!');
            return Upload.LIST_IGNORE;
        }
        return true; 
    },
};

const normFile = (e: any) => {
    if (Array.isArray(e)) return e;
    return e?.fileList || []; 
};


export const AgreementUpload = ({ initialFile }: { initialFile?: string }) => {
    const [fileList, setFileList] = useState<any[]>([]); 

    useEffect(() => {
        
        if (initialFile && typeof initialFile === 'string') {
            setFileList([{
                uid: '-1',
                name: initialFile.split('/').pop(),
                status: 'done',
                url: initialFile
            }]);
        } else {
            setFileList([]); 
        }
    }, [initialFile]);

    return (
        <Form.Item
            name="document"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            noStyle
        >
            <Upload
                name="document"
                {...uploadProps}
                fileList={fileList}
                onRemove={() => setFileList([])} 
                onChange={({ fileList }) => setFileList(fileList)}
            >
                <Button
                    onClick={() => {
                        if (fileList.length > 0) {
                            window.open(fileList[0].url, '_blank');
                        }
                    }}
                >
                    Upload
                </Button>
            </Upload>
        </Form.Item>
    );
};


export const statusOptions = [
    { value: 1, label: "Active" },
    { value: 2, label: "Deactive" },
];


export default useCustomerModal;